<template>
  <v-flex xs12 sm8 md4 lg4>
    <v-form>
      <v-card class="elevation-4 pa-3">
        <v-card-text>
          <div class="layout column align-center">
            <img
              src="@/assets/logo-120x120.png"
              :alt="sistem.app_title"
              height="120"
            />
            <h1
              class="mt-3 mb-5 display-1 font-weight-regular"
              :class="`${sistem.app_theme}--text`"
            >
              Lupa Password
            </h1>
          </div>
          <span class="font-weight-regular font-italic">
            Masukkan email Anda untuk mendapatkan link ganti password.
          </span>
          <v-text-field
            append-icon="email"
            autofocus
            type="text"
            v-model="input.email"
            v-validate="'required|email'"
            name="email"
            data-vv-name="email"
            label="E-Mail"
            data-vv-as="E-Mail"
            :error-messages="errors.collect('email')"
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <public-menus></public-menus>
          <v-spacer></v-spacer>
          <v-btn
            :color="sistem.app_theme"
            dark
            type="submit"
            @click.prevent="submit"
            >Kirim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</template>

<script>
import { mapState } from "vuex";
import PublicMenus from "@/components/public/PublicMenus";

export default {
  name: "lupa-password",
  components: {
    PublicMenus
  },
  data() {
    return {
      input: {
        email: ""
      }
    };
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("sistem", ["sistem"])
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store.dispatch("auth/LUPA_PASSWORD", this.input);
        }
      });
    }
  }
};
</script>
